import React from 'react'
import { Spinner, Typography } from '@telavita-core/react-design-kit'

import { ReactComponent as CheckSuccessIcon} from 'static/svg/icon-check-green.svg'
import { ReactComponent as CheckErrorIcon} from 'static/svg/icon-check-red.svg'

import * as S from './styles'

interface PinSendedMessageProps {
  hasPinError: boolean
  resendPinLoading: boolean
}

const LoadingPinMessage = () => (
  <>
    <Spinner customClassName='resendPinLoadingSpinner' />
    <S.WrapperText>
      <Typography color='primary' weight='bold' variant='content2'>
        Reenviando PIN...
      </Typography>
      <Typography variant='content2'>
        Em instantes você receberá um novo SMS.
      </Typography>
    </S.WrapperText>
  </>
)

const SuccessPinMessage = () => (
  <>
    <CheckSuccessIcon width={20} height={20} />
    <S.WrapperText>
      <Typography color='success' weight='bold' variant='content2'>
        Pin enviado com sucesso!
      </Typography>
      <Typography variant='content2'>
        Confira o SMS em seu celular e digite abaixo.
      </Typography>
    </S.WrapperText>
  </>
)

const ErrorPinMessage = () => (
  <>
    <CheckErrorIcon width={20} height={20} />
    <S.WrapperText>
      <Typography color='danger' weight='bold' variant='content2'>
        O PIN está incorreto!
      </Typography>
      <Typography variant='content2'>
        Por favor, revise o código digitado.
      </Typography>
    </S.WrapperText>
  </>
)

export const PinSendedMessage: React.FC<PinSendedMessageProps> = ({
  hasPinError,
  resendPinLoading
}) => {

  function renderCorrectPinMessage() {
    if (resendPinLoading) {
      return <LoadingPinMessage />
    }

    if (hasPinError) {
      return <ErrorPinMessage />
    }

    return <SuccessPinMessage />
  }

  return (
    <S.Container>
      {renderCorrectPinMessage()}
    </S.Container>
  )
}